import { useNumberInput } from '@chakra-ui/react'

export default useNumberInput
